/**
 * Валидаторы, которые поочередно будут применены к каждому полю формы
 * Первый положительный будет отображен как ошибка
 */
define( 'mrg-form/b-form/b-form.validators', ['jquery'], function($) {
	'use strict';

	return {

		/**
		 * Валидатор проверяет у поля есть data-invalid
		 * @return {string|boolean} - тип ошибки (значение атрибута)
		 */
		invalid: function () {
			var error = this.$el.attr('data-invalid');

			if (!error) {
				return false;
			} else {
				return error;
			}

		},

		required: function ($field, val) {

			if (typeof val === 'string') {
				val = val.trim();
			}

			return ($field.attr('required') || $field.attr('data-required')) && !val;
		},

		/**
		 * Для SWA длинна строки считаются в байтах
		 * поэтому переводим строку по этому методу
		 * http://stackoverflow.com/questions/5515869/string-length-in-bytes-in-javascript
		 *
		 * @param {JQuery} $field
		 * @returns {boolean}
		 */
		maxbytes: function ($field) {
			var maxbytes = $field.data('maxbytes'),
				value;

			if (maxbytes <= 0) {
				return false;
			}

			value =  encodeURI($field.val()).split(/%..|./);
			return value.length - 1 > maxbytes;
		},

		maxlength: function ($field) {
			var maxlength = $field.data('maxlength'),
				value = $field.val();

			if (maxlength <= 0) {
				return false;
			}

			return value.length - 1 > maxlength;
		},

		/**
		 * Для SWA длинна строки считаются в байтах
		 * поэтому переводим строку по этому методу
		 * http://stackoverflow.com/questions/5515869/string-length-in-bytes-in-javascript
		 *
		 * @param {JQuery} $field
		 * @returns {boolean}
		 */
		minbytes: function ($field) {
			var minbytes = $field.data('minbytes'),
				value;

			value =  encodeURI($field.val()).split(/%..|./);
			return minbytes > value.length - 1;
		},

		minlength: function ($field) {
			var minlength = $field.data('minlength'),
				value = $field.val();

			return minlength > value.length - 1;
		},

		pattern: function ($field, val) {
			var bemPattern;
			try{
				bemPattern = $field.getBlock().getData().props.pattern;
			} catch(error) {}

			return !(new RegExp($field.data().pattern || bemPattern || '')).test(val);
		},

		retryfor: function ($field, val) {
			var masterName = $field.attr('data-retryfor'),
				$master;

			if (!masterName) {
				return false;
			}

			$master = $('[name="' + masterName + '"]');
			return !($master && $master.val() === val);
		},

		refutefor: function ($field, val) {
			var masterName = $field.attr('data-notequals'),
				$master;

			if (!masterName) {
				return false;
			}

			$master = $('[name="' + masterName + '"]');
			return !($master && $master.val() !== val);
		},

		max: function ($field, value) {
			var max = +$field.data('max');

			return value > max;
		}

	};


});
